<template>
  <div class="card">
    <div class="bg-blue-light p-2">
      <TitleButton :showBtn="false" title="Payment Requisition - Disbursement" />
    </div>

    <div class="px-3 mt-2">
      <ul class="nav nav-tabs custom-nav-tab">
        <li v-for="tab in tabs" :key="tab.id" class="nav-item">
          <a
            :class="['nav-link', { active: activeTab === tab.id }]"
            @click="setActiveTab(tab.id)"
          >
            {{ tab.title }}
          </a>
        </li>
      </ul>
    </div>

    <div class="p-2">
      <MakePaymentTab v-if="activeTab === 'make_payment'" />
      <ClearanceTab v-if="activeTab === 'clearance'" />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import TitleButton from '@/components/atom/TitleButton'
import MakePaymentTab from './disbursement/MakePaymentTab.vue'
import ClearanceTab from './disbursement/ClearanceTab.vue'

const tabs = [
  { id: 'make_payment', title: 'Make Payment' },
  { id: 'clearance', title: 'Clearance' },
]

const activeTab = ref('make_payment')

const setActiveTab = (id) => {
  activeTab.value = id
}
</script>
